const MAX_TEXT_CHARS = 120000;

export function truncateForModel(text, fileName) {
  const s = (text || '').trim();
  if (s.length <= MAX_TEXT_CHARS) return s;
  return `${s.slice(0, MAX_TEXT_CHARS)}\n\n[Truncated — ${fileName} was very large.]`;
}

function readArrayBuffer(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsArrayBuffer(file);
  });
}

export async function extractDocxText(file) {
  const mammoth = (await import('mammoth')).default;
  const arrayBuffer = await readArrayBuffer(file);
  const result = await mammoth.extractRawText({ arrayBuffer });
  const text = (result.value || '').trim();
  if (!text) throw new Error('No text found in document.');
  return truncateForModel(text, file.name);
}

export async function extractExcelText(file) {
  const XLSX = await import('xlsx');
  const arrayBuffer = await readArrayBuffer(file);
  const wb = XLSX.read(arrayBuffer, { type: 'array' });
  let out = '';
  wb.SheetNames.forEach((name) => {
    const sheet = wb.Sheets[name];
    out += `\n--- Sheet: ${name} ---\n`;
    out += XLSX.utils.sheet_to_csv(sheet);
  });
  const text = out.trim();
  if (!text) throw new Error('No data found in spreadsheet.');
  return truncateForModel(text, file.name);
}

export async function extractPptxText(file) {
  const JSZip = (await import('jszip')).default;
  const arrayBuffer = await readArrayBuffer(file);
  const zip = await JSZip.loadAsync(arrayBuffer);
  const slidePaths = Object.keys(zip.files)
    .filter((n) => /^ppt\/slides\/slide\d+\.xml$/i.test(n))
    .sort((a, b) => {
      const na = parseInt(a.match(/slide(\d+)/i)?.[1] || '0', 10);
      const nb = parseInt(b.match(/slide(\d+)/i)?.[1] || '0', 10);
      return na - nb;
    });
  if (!slidePaths.length) throw new Error('No slides found in presentation.');
  let text = '';
  for (const path of slidePaths) {
    const xml = await zip.files[path].async('string');
    const slideNum = path.match(/slide(\d+)/i)?.[1] || '?';
    const parts = [...xml.matchAll(/<a:t[^>]*>([^<]*)<\/a:t>/g)].map((m) => m[1]);
    if (parts.length) text += `--- Slide ${slideNum} ---\n${parts.join(' ')}\n\n`;
  }
  const trimmed = text.trim();
  if (!trimmed) throw new Error('No text found in presentation.');
  return truncateForModel(trimmed, file.name);
}

export function formatDocAttachment(fileName, body, kind = 'file') {
  return {
    type: 'doc',
    fileName,
    kind,
    extractedText: body,
  };
}
